var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 20.631,
    viewBox: "0 0 21.5 20.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-chat",
    transform: "translate(16178.75 23329.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.75,20.63a1.764,1.764,0,0,1-.83-.21A1.741,1.741,0,0,1,5,18.88V17.46a5.392,5.392,0,0,1-5-5.71v-6A5.443,5.443,0,0,1,5.75,0h10A5.443,5.443,0,0,1,21.5,5.75v6a5.443,5.443,0,0,1-5.75,5.75H11.98L7.72,20.34A1.777,1.777,0,0,1,6.75,20.63Zm-1-19.14A3.984,3.984,0,0,0,1.5,5.74v6a3.984,3.984,0,0,0,4.25,4.25.755.755,0,0,1,.75.75v2.13a.252.252,0,0,0,.39.21l4.45-2.96a.771.771,0,0,1,.42-.13h4a3.984,3.984,0,0,0,4.25-4.25v-6a3.984,3.984,0,0,0-4.25-4.25Z",
    transform: "translate(-16178.75 -23329.311)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.492,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H12.492a.755.755,0,0,1,.75.75A.755.755,0,0,1,12.492,1.5Z",
    transform: "translate(-16174.75 -23323.75)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.492,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H8.492a.755.755,0,0,1,.75.75A.755.755,0,0,1,8.492,1.5Z",
    transform: "translate(-16174.75 -23319.75)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/Icon-chat.5969e5df85fc7f7b22992d430818757f.svg";
export { ForwardRef as ReactComponent };